<template>
  <div class="release-list-noData">
    <img class="release-list-noData-img" :src="g_imgSrc.bgWhite" />
    <div class="release-list-noData-word">暂无相关内容</div>
  </div>
</template>

<script>
export default {
  name: 'NoData',
};
</script>
<style lang="scss" scoped>
.release-list-noData {
  width: 100%;
  height: 100%;
  text-align: center;
  .release-list-noData-img {
    width: 240px;
    height: 192px;
    margin-top: 100px;
  }
  .release-list-noData-word {
    font-size: 16px;
    color: #606266;
    text-align: center;
    margin-top: 16px;
    height: 50px;
  }
}
</style>
